export const alimtalkToastMsg = {
  /** CSV 업로드 */
  UPLOAD_CSV_REQUEST_ERROR: 'CSV 업로드에 실패했습니다.',

  /** 발송 등록 */
  CREATE_SEND_REQUEST_SUCCESS: '발송이 등록되었습니다.',
  CREATE_SEND_REQUEST_ERROR: '발송 등록에 실패했습니다.',

  /** 테스트 발송 */
  TEST_SEND_REQUEST_SUCCESS: '테스트 발송이 완료되었습니다.',
  TEST_SEND_REQUEST_ERROR: '테스트 발송에 실패했습니다.',
} as const;
